import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";

interface JWTPayload {
  exp: number;
  uuid: string; // either user uuid or admin uuid
}

export const decodeJwt = (token: string) => {
  return jwtDecode<JWTPayload>(token);
};

export const getTokenExpireTimestamp = (token: string) => {
  const decoded = jwtDecode(token);
  const { exp = 0 } = decoded;
  const timestamp = dayjs(exp * 1000);
  return timestamp;
};

export const isExpired = (token: string) => {
  try {
    const timestamp = getTokenExpireTimestamp(token);
    return timestamp.isBefore(dayjs());
  } catch (err) {
    // if we can't parse the token, lets agree it is expired
    return true;
  }
};
